import { FC, useState } from 'react'
import PerText from '../Text'
import { useTranslation } from 'react-i18next'
import PerFlexRow from '../FlexRow'
import PerButtonCircle from '../ButtonCircle'
import { Modal } from 'antd'
import PerButton from '../Button'

export interface DeleteTargetTemplateModalProps {
  isOpen: boolean
  onClose: () => void
  onCancelTargetTemplate: () => Promise<void>
}
export const DeleteTargetTemplateModal: FC<DeleteTargetTemplateModalProps> = ({ isOpen, onClose, onCancelTargetTemplate }) => {
  const [isDeleting, toggleDeleting] = useState<boolean>(false)
  const { t } = useTranslation()

  const confirmDeletion = async () => {
    toggleDeleting(true)
    await onCancelTargetTemplate()
    toggleDeleting(false)
  }

  return (
    <>
      <Modal
        title={
          <PerFlexRow justify="space-between" align="middle">
            <PerFlexRow>
              <PerText fontSize="xl" color="primary">
                {t('cancelTargetTemplateModal.title')}
              </PerText>
            </PerFlexRow>
            <PerButtonCircle
              size="large"
              icon="close_stroke"
              color="transparent"
              onClick={() => {
                onClose()
              }}
              testid="tm-modal-close"
            />
          </PerFlexRow>
        }
        visible={isOpen}
        centered
        closable={false}
        footer={
          <PerFlexRow align="middle" justify="space-between">
            <PerFlexRow>
              <PerButton
                text={t('global.button.cancel')}
                color="secondary"
                before="close_stroke"
                variant="pastel"
                type="button"
                onClick={onClose}
                data-e2e-modal-footer-button="cancel"
              />
            </PerFlexRow>
            <PerFlexRow align="middle">
              <PerButton
                text={t('global.button.delete')}
                color="error"
                before="delete_fill"
                variant="pastel"
                type="button"
                onClick={async () => {
                  await confirmDeletion()
                }}
                isProcessing={{ active: isDeleting }}
                data-e2e-settings-modal-button="confirm"
              />
            </PerFlexRow>
          </PerFlexRow>
        }
        destroyOnClose
        className="per-modal per-modal--large"
      >
        <PerText>{t('cancelTargetTemplateModal.description')} </PerText>
      </Modal>
    </>
  )
}
